import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {first} from 'rxjs/operators';
import {UserService} from '../_services';
import {getUser, setUser, setToken} from '../../assets/utils.js';
import {Router} from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  constructor(private router: Router, private userService: UserService) {
      if (getUser()) {
          this.router.navigate(['/dashboard']);
      }
  }

    loginForm = new FormGroup({
        email: new FormControl(''),
        password: new FormControl(''),
    });

    onSubmit() {

        this.userService.login(this.loginForm.value.email, this.loginForm.value.password).pipe(first()).subscribe(result => {

            const token = result as any;
            if (token.user) {
                setUser(token.user);
                setToken(token.id);
                this.router.navigate(['/dashboard']);
            } else {
                alert("Mauvais email ou mot de passe !");
            }

        });

    }

}
